var SEOData = React.createContext({});
export var SEODataProvider = SEOData.Provider;
export var SEODataConsumer = SEOData.Consumer;
export default SEOData;